import styled from 'styled-components';

export const CardWrapper = styled('div')`
  ${({ theme }) => `
    width: 100%;
    max-width: ${theme.spacing.full};
    box-sizing: border-box;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
      background:transparent;
      box-shadow:none;
      margin-left: auto;
      margin-right: auto;
    }
  `}
`;

export const TitleWrapper = styled('div')`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    text-align:center;
    margin-top:100px;
    font-size:24px;
    color:#0C2833;
    @media screen and (max-width: ${theme.breakpoint.sm}) {
      margin-top:83px;
    }
  `}
`;

export const TextWrapper = styled('div')`
  ${({ theme }) => `
    display: block;
    align-items: center;
    justify-content: center;
    font-size:24px;
    text-align:center;
    font-weight:bold;
    margin-top:10px;
    color:#0C2833;

    @media screen and (max-width: ${theme.breakpoint.sm}) {

    }
  `}
`;
